module.exports = __webpack_public_path__ + "img/DiaryBarham-Warzsh.adc31c1e.jpg";